import { Reducer } from 'redux';
import { Segment } from '~src/interfaces/segment.interface';

import {
  GET_GROUP_ANSWERS_SUCCESS,
  GET_GROUP_BY_ID_SUCCESS,
  GET_GROUP_QUESTIONS_IMPROVE_SUCCESS,
  GET_GROUP_NEWS_SUCCESS,
  GET_GROUP_QUESTIONS_SUCCESS,
  GET_GROUP_TOPICS_SUCCESS,
  GROUP_PROFILE_ANY_FAILED,
  GROUP_PROFILE_ANY_REQUEST,
} from '~src/modules/reports/groupProfile/constants/actions';
import {
  defaultInitState,
  ProfileState,
  resultListToObject,
} from '~src/modules/reports/shared/distributers/actionDistributor';
import { ThunkFailAction, ThunkSuccessAction } from '~src/services/apiMiddleware';
import { ReportSubjectTypes } from '~src/modules/reports/interfaces/header.interface';
import { QuestionResponse } from '~src/modules/reports/interfaces/questions.interface';
import { AnswerResponse } from '~src/modules/reports/interfaces/answer.interface';
import { NewsResponse } from '~src/modules/reports/interfaces/news.interface';

export interface GroupProfileState extends ProfileState {
  currentGroup: Segment | null;
}

export function getInitialGroupProfileState(): GroupProfileState {
  return {
    ...defaultInitState,
    currentGroup: null,
  };
}

const groupProfileReducer: Reducer<GroupProfileState, ThunkSuccessAction | ThunkFailAction> = (
  state: GroupProfileState = getInitialGroupProfileState(),
  action,
) => {
  switch (action.type) {
    case GROUP_PROFILE_ANY_REQUEST: {
      return { ...state, loading: true };
    }
    case GROUP_PROFILE_ANY_FAILED: {
      return { ...state, loading: false };
    }
    case GET_GROUP_BY_ID_SUCCESS: {
      return { ...state, loading: false, currentGroup: action.response.data };
    }
    case GET_GROUP_TOPICS_SUCCESS: {
      return {
        ...state,
        loading: false,
        topics: resultListToObject(ReportSubjectTypes.Topic, action.response.data),
      };
    }
    case GET_GROUP_QUESTIONS_SUCCESS: {
      return {
        ...state,
        loading: false,
        questions: resultListToObject<QuestionResponse>(ReportSubjectTypes.Question, action.response.data),
      };
    }
    case GET_GROUP_ANSWERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        answers: resultListToObject<AnswerResponse>(ReportSubjectTypes.Answer, action.response.data),
      };
    }
    case GET_GROUP_QUESTIONS_IMPROVE_SUCCESS: {
      return {
        ...state,
        loading: false,
        questions_improve: resultListToObject(ReportSubjectTypes.QuestionsImprove, action.response.data),
      };
    }
    case GET_GROUP_NEWS_SUCCESS: {
      return {
        ...state,
        loading: false,
        news: resultListToObject<NewsResponse>(ReportSubjectTypes.News, action.response.data),
      };
    }
    default:
      return state;
  }
};

export default groupProfileReducer;
